import { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import I18n from 'i18n-js';

import { useIsRadarEnabled } from '~/redux/hooks/useIsRadarEnabled';
import { JOBS_PATH, RADAR_PATH } from '~/routes/paths';
import { getMainViewTabs } from '~/routes/routeComponents';

import styles from './TabNavigation.module.scss';

export default function TabNavigation({
  hide,
  search,
}: {
  hide: boolean;
  search: boolean;
}): JSX.Element {
  const isRadarEnabled = useIsRadarEnabled();

  const mainViewTabs = useMemo(() => {
    return getMainViewTabs(
      isRadarEnabled ? [JOBS_PATH] : [JOBS_PATH, RADAR_PATH],
    );
  }, [isRadarEnabled]);

  return (
    <div
      className={classNames(styles.tabNavigation, {
        [styles.hide]: hide,
        [styles.hideSearch]: search,
      })}
    >
      {mainViewTabs.map(({ tab: { translation, icon: Icon }, path, exact }) => (
        <NavLink
          to={path}
          key={path}
          className={styles.tab}
          activeClassName={styles.isSelected}
          exact={exact}
        >
          {Icon && <Icon className={styles.tabIcon} />}
          <span>{I18n.t(translation)}</span>
        </NavLink>
      ))}
    </div>
  );
}
